// Text items of a PDF page (string + position, as pdf.js reports them) → reading-order lines. Cells that sit far
// apart on the same line (a label on the left, its amount in a column on the right; two columns side by side) are
// separated by a TAB, so parsers can tell "Social insurance<TAB>246,40" from "Social insurance 246,40 Tax 120,35".
// Pure function (no DOM): used by the CRM, the website and the tests.

export interface PdfTextItem { str: string; x: number; y: number; w: number; h: number }

export function linesFromTextItems(items: PdfTextItem[]): string[] {
  const parts = items.filter((i) => i.str && i.str.trim() !== '').map((i) => ({ ...i, h: i.h > 0 ? i.h : 10 }));
  if (!parts.length) return [];
  // rows: items whose baselines are within ~45% of the text height belong to the same line
  parts.sort((a, b) => b.y - a.y || a.x - b.x);
  const rows: PdfTextItem[][] = [];
  for (const it of parts) {
    const row = rows.find((r) => Math.abs(r[0]!.y - it.y) <= Math.max(r[0]!.h, it.h) * 0.45);
    if (row) row.push(it); else rows.push([it]);
  }
  rows.sort((a, b) => b[0]!.y - a[0]!.y);
  return rows.map((row) => {
    row.sort((a, b) => a.x - b.x);
    let line = '';
    let end = -Infinity;
    for (const it of row) {
      const gap = it.x - end;
      if (line) {
        if (gap > it.h * 1.6) line = line.replace(/\s+$/, '') + '\t';
        else if (gap > it.h * 0.12 && !/\s$/.test(line) && !/^\s/.test(it.str)) line += ' ';
      }
      line += it.str;
      end = it.x + Math.max(0, it.w);
    }
    return line.replace(/[  ]+/g, ' ').replace(/ ?\t ?/g, '\t').trim();
  }).filter(Boolean);
}
